import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import './NotFound404.css';

export default function NotFound404() {
  const { t } = useTranslation();
  return (
    <div className="notfound-page">
      <div className="notfound-content">
        <h1 className="notfound-title">404</h1>
        <p className="notfound-message">{t('notFound.title')}</p>
        <p className="notfound-hint">
          <Trans i18nKey="notFound.hint" components={{ code: <code /> }} />
        </p>
      </div>
    </div>
  );
}
